'use-client';
import { Button, IconButton } from "@mui/material";
import styles from './downloadAppOverlay.module.css';
import CloseIcon from '@mui/icons-material/Close';
import { NEXT_PUBLIC_APP_STORE_LINK, NEXT_PUBLIC_PLAY_STORE_LINK } from "@/config/constants";
import { isIOS, isMobile } from "react-device-detect";
import { useEffect, useState } from "react";
import { getCookieValue, setCookie } from "@/services/cookieService";
import { useRouter } from "next/router";
import enDownloadAppContents from '@/locales/en/downloadAppContents';
import arDownloadAppContents from '@/locales/ar/downloadAppContents';
import { event } from "@/lib/ga";

const DownloadAppOverlay = () => {
    const router: any = useRouter();
    const { locale } = router;
    const tDownloadAppContents = locale == 'en' ? enDownloadAppContents : arDownloadAppContents;

    const [showOverlay, setShowOverlay] = useState(false);

    const dismissOverlay = () => {
        const cookieName = 'hideDownloadOverlay';
        const cookieValue = 'true';
        const expiryMinute = 24 * 60;
        setCookie(cookieName, cookieValue, expiryMinute);
        setShowOverlay(false);
    }

    const redirectToStore = () => {
        if (isIOS)
            window.open(NEXT_PUBLIC_APP_STORE_LINK, '_blank');
        else
            window.open(NEXT_PUBLIC_PLAY_STORE_LINK, '_blank');
    }

    const isShowOverlay = () => {
        const hideOverlay = getCookieValue('hideDownloadOverlay');
        return hideOverlay != 'true';
    }

    useEffect(() => {
        if (isMobile) {
            setShowOverlay(true);
        }
    }, [])


    return (showOverlay && isShowOverlay()) ? <div className={styles.downloadOverlay}>
        <div className={styles.closeBtnStyle}>
            <IconButton aria-label="delete" onClick={dismissOverlay}>
                <CloseIcon fontSize="small" />
            </IconButton>
        </div>
        <div className={styles.overlayBody}>
            <div className={styles.logo}>
                <img src="/live/en/iceridgeresources/images/loggedOut-logo.svg" ></img>
            </div>
            <p className={styles.displayText}>{tDownloadAppContents.DOWNLOAD_APP_DESC}</p>
            <Button variant="outlined" href="#outlined-buttons" className={styles.downloadButton} onClick={() => {
                event({
                    action: "downloadApp",
                    params: {
                        category: "button",
                        label: "Download App"
                    }
                });
                redirectToStore()
            }}>
                {tDownloadAppContents.DOWNLOAD_APP_TEXT}
            </Button>
        </div>
    </div> : <></>;
}

export default DownloadAppOverlay;